import {
    GET_PROMPT_TAGS,
    ADD_PROMPT_TAG,
    GET_PROMPTS,
    ADD_PROMPT,
    UPDATE_PROMPT,
    DELETE_PROMPT,
    API_RESPONSE_SUCCESS,
    API_RESPONSE_ERROR
} from "./actionType";

const initialState = {
    promptTags: [],
    prompts: [],
    error: {},
    loading: false
};

const Prompts = (state = initialState, action) => {
    switch (action.type) {
        case GET_PROMPT_TAGS:
        case ADD_PROMPT_TAG:
        case GET_PROMPTS:
        case ADD_PROMPT:
        case UPDATE_PROMPT:
        case DELETE_PROMPT:
            return {
                ...state,
                loading: true,
                error: null
            };

        case API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case GET_PROMPT_TAGS:
                    return {
                        ...state,
                        promptTags: action.payload.data || [],
                        loading: false,
                        error: null
                    };
                case ADD_PROMPT_TAG:
                    return {
                        ...state,
                        loading: false,
                        error: null,
                        promptTags: [...state.promptTags, action.payload.data]
                    };
                case GET_PROMPTS:
                    return {
                        ...state,
                        prompts: action.payload.data || [],
                        loading: false,
                        error: null
                    };
                case ADD_PROMPT:
                    return {
                        ...state,
                        loading: false,
                        error: null,
                        prompts: [...state.prompts, action.payload.data]
                    };
                case UPDATE_PROMPT:
                    return {
                        ...state,
                        loading: false,
                        error: null,
                        prompts: state.prompts.map(prompt => 
                            prompt._id === action.payload.data._id ? action.payload.data : prompt
                        )
                    };
                case DELETE_PROMPT:
                    return {
                        ...state,
                        loading: false,
                        error: null,
                        prompts: state.prompts.filter(prompt => prompt._id !== action.payload.data.id)
                    };
                default:
                    return state;
            }

        case API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case GET_PROMPT_TAGS:
                case ADD_PROMPT_TAG:
                case GET_PROMPTS:
                case ADD_PROMPT:
                case UPDATE_PROMPT:
                case DELETE_PROMPT:
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false
                    };
                default:
                    return state;
            }

        default:
            return state;
    }
};

export default Prompts; 